import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../store";
import {
  loginSuccess,
  PermissionMap,
  User,
} from "../../store/slices/authSlice";
import { apiRequest } from "../../utils/apiClient";

interface Props {
  open: boolean;
  onClose: () => void;
}
interface LoginResponse {
  token: string;
  user: User;
  permissions: PermissionMap;
  sessionExpiresAt: number;
}

const LoginModal: React.FC<Props> = ({ open, onClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await apiRequest<LoginResponse>(
        "/api/auth/login",
        "POST",
        {
          email,
          password,
        },
      );

      const { data } = response as {
        data: {
          token: string;
          user: any;
          permissions: any;
        };
      };

      dispatch(
        loginSuccess({
          user: response.data.user,
          token: response.data.token,
          permissions: response.data.permissions,
          sessionExpiresAt: response.data.sessionExpiresAt,
        }),
      );

      onClose();
    } catch (err: any) {
      if (err.response?.status === 401) {
        alert("Invalid email or password");
      } else {
        alert("Something went wrong. Please try again.");
      }
      console.error("Errrrrrrrrrrrrrorrr: ", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Login</Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box component="form" onSubmit={handleLogin} mt={2}>
          <TextField
            fullWidth
            label="Email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            fullWidth
            label="Password"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Login
          </Button>

          <Button
            fullWidth
            sx={{ mt: 1 }}
            // onClick={handleRegister}
            href="/clientRegistration"
          >
            Register
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
